export default "__VITE_ASSET__d9c52338__"